module.exports = __webpack_public_path__ + "static/media/photo.e60bbe86.jpg";